<template>
  <div>
    <BAlert
      v-if="!isEmpty(resultCalculatePrice) && resultCalculatePrice[0]?.bargainFinder"
      show
      variant="danger"
      class="px-50"
    >
      Quan trọng:<br>
      Có sự thay đổi về giá và hạng đặt chỗ. Vui lòng kiểm tra cẩn thận trước khi lưu. Hạng vé <span class="fw-700">MÀU ĐỎ</span> là hạng vé bị thay đổi!
    </BAlert>

    <b-tabs
      v-if="resultCalculatePrice"
      nav-class="bg-gray"
      pills
    >
      <b-tab
        :title="$t(`flight['Pricing information']`)"
        title-item-class="fw-700"
        title-link-class="px-75 hover-bg-light-warning"
        active
      >
        <BTable
          small
          responsive
          hovered
          outlined
          :items="resultCalculatePrice"
          class="mb-0 mt-25"
          thead-tr-class="text-nowrap"
          tbody-tr-class="text-nowrap text-right"
          :fields="['passenger', 'quantity', 'net', 'tax', 'total']"
        >
          <template
            v-for="(column, indexColumn) in [
              'passenger',
              'quantity',
              'net',
              'tax',
              'total',
            ]"
            #[`head(${column})`]="data"
          >
            <div
              :key="indexColumn"
              :class="`${
                indexColumn === 0 ? 'text-center' : 'text-right'
              }`"
            >
              {{ $t(`reservation.${data.column}`) }}
            </div>
          </template>

          <template #cell(passenger)="{ item }">
            {{ $t(`flight.${capitalize(item.passengerRequested.paxType)}`) }}
          </template>
          <template #cell(quantity)="{ item }">
            {{ item.passengerRequested.quantity }}
          </template>
          <template #cell(net)="{ item }">
            <span class="fw-600">
              {{ formatCurrency(item.basePrice, item.currency) }}
            </span>
          </template>
          <template #cell(tax)="{ item }">
            <span class="fw-600">
              {{ formatCurrency(item.totalTaxes, item.currency) }}
            </span>
          </template>
          <template #cell(total)="{ item }">
            <span class="fw-600 text-airline">
              {{ formatCurrency(item.totalPrice, item.currency) }}
            </span>
          </template>
        </BTable>

        <div class="text-right fw-700 mr-50">
          <span class="mr-2">
            {{ $t('flight.totalTickerFare') }}
          </span>
          <span class="text-danger">
            {{ formatCurrency(resultCalculatePrice.reduce((acc, item) => acc + item.totalPrice, 0), resultCalculatePrice[0].currency) }}
          </span>
        </div>
      </b-tab>

      <b-tab
        :title="$t('flight.priceInformation') "
        title-item-class="fw-700 border-left-secondary"
        title-link-class="px-75 hover-bg-light-warning"
      >
        <ShortenBooking :shorten-text="resultCalculatePrice?.[0]?.fareDetails || undefined" />
      </b-tab>

      <b-tab
        title="Điều kiện"
        title-item-class="fw-700 border-left-secondary"
        title-link-class="px-75 hover-bg-light-warning"
      >
        <ShortenBooking :shorten-text="resultCalculatePrice?.[0]?.fareRules || undefined" />
      </b-tab>

      <b-tab
        title="Hành lý"
        title-item-class="fw-700 border-left-secondary border-right-secondary"
        title-link-class="px-75 hover-bg-light-warning"
      >
        <ShortenBooking :shorten-text="resultCalculatePrice?.[0]?.bagInfo || undefined" />
      </b-tab>
    </b-tabs>

    <div
      v-else
      class="text-warning font-italic mx-1"
    >
      Chưa tính giá
    </div>
  </div>
</template>

<script>
import {
  BTable, BTabs, BTab,
  BAlert,
} from 'bootstrap-vue'
import { capitalize, isEmpty } from 'lodash-es'
// import {
//   onBeforeUpdate,
// } from '@vue/composition-api'

import { formatCurrency } from '@core/utils/filter'

import useClassBookingPro from './useClassBookingPro'

export default {
  components: {
    BTable,
    BTabs,
    BTab,
    BAlert,
    ShortenBooking: () => import('./ShortenBooking.vue'),
  },
  setup() {
    // onBeforeUpdate(() => {
    //   console.log("UPDATE'ClassBookingProBookPrice' ")
    // })

    const {
      resultCalculatePrice,
    } = useClassBookingPro()

    return {
      resultCalculatePrice,
      capitalize,
      isEmpty,
      formatCurrency,
    }
  },
}
</script>

<style lang="scss">

</style>
